const constants = {
  LOGGER_CLEAN_LOG: 'LOGGER_CLEAN_LOG',
};

export default constants;
